import { Flex } from "@chakra-ui/react";
import Footer from "./Footer";
import Contact from "./Contact";
import Features from "./Features";
import Header from "./Header";
import Hero from "./Hero";
import Collaborators from "./Collaborators";

export default function Home() {
  return (
      <Flex direction="column" minH="100vh">
        <Header />
        <Hero />
        <Features />
        <Collaborators />
        <Contact />
        <Footer />
      </Flex>
  );
}
